
import FieldNote from 'JS/components/FieldNote.vue';
import Icon from 'JS/components/Icon.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed, defineComponent } from 'vue';

export default defineComponent({
	name: 'AddVehicle',
	components: {
		FieldNote,
		Icon,
		UiButton
	},
	emits: ['add-vehicle'],
	props: {
		isBattery: {
			type: Boolean,
			default: false
		},
		isTire: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const vehicleAction = computed(() => {
			if (props.isBattery) {
				return 'to make sure this battery fits';
			}

			if (props.isTire) {
				return 'to make sure these tires fit';
			}

			return 'to select services';
		});

		return {
			vehicleAction
		};
	}
});
